export default __webpack_public_path__ + "static/media/ico_circle.01002f05.svg";